<template>
	<v-container align-center>
		<v-layout justify-center>
			<v-flex>
				<v-layout justify-center row wrap>
					<v-flex>
						<v-autocomplete
							v-model="selectedYear"
							label="Select Year"
							:items="filterYears"
							:autcomplete="false"
							placeholder="Year"
							class="text-field-wrapper pt-4"
							clearable
						/>
					</v-flex>
					<v-flex>
						<v-autocomplete
							v-model="selectedMonth"
							label="Select Month"
							:items="filterMonths"
							:autcomplete="false"
							placeholder="Month"
							class="text-field-wrapper pt-4"
							clearable
						/>
					</v-flex>
				</v-layout>
				<v-layout justify-center>
					<v-btn
						round
						:dark="!!selectedYear && !!selectedMonth"
						:color="themeInputColor"
						:disabled="!selectedYear || !selectedMonth"
						:loading="isInvoiceFetching"
						@click="getInvoices"
					>
						Get Approved Invoices
					</v-btn>
				</v-layout>
				<v-layout justify-center>
					<v-btn
						round
						:dark="!!selectedYear && !!selectedMonth"
						:color="themeInputColor"
						:disabled="!selectedYear || !selectedMonth"
						:loading="isBulkApprovalInProgress"
						@click="uploadBulkApprovalCsv"
					>
						Upload Bulk Approve CSV
					</v-btn>
				</v-layout>
				<v-flex class="pos-rel">
					<input
						ref="inputUpload"
						type="file"
						@change="onFileChange"
						required
						class="input"
						style="display: none"
					/>
				</v-flex>
				<v-data-table
					:headers="headers"
					:items="approvedInvoices"
					class="elevation-1 mt-4"
					:hide-actions="true"
				>
					<template v-slot:items="props">
						<tr>
							<td class="text-xs-center">
								{{ props.item.retailerName }}
							</td>
							<td class="text-xs-center">
								{{ props.item.dstrId }}
							</td>
							<td class="text-xs-center">
								{{ props.item.city }}
							</td>
							<td class="text-xs-center">
								{{ props.item.state }}
							</td>
							<td
								@click="viewInvoice(props.item)"
								class="text-xs-center"
							>
								<v-icon>visibility</v-icon>
							</td>
							<td
								@click="downloadInvoice(props.item)"
								class="text-xs-center"
							>
								<v-icon>download</v-icon>
							</td>
						</tr>
					</template>
				</v-data-table>
				<v-layout justify-center>
					<v-btn
						v-if="showLoadMore"
						:dark="!!selectedYear && !!selectedMonth"
						:color="themeInputColor"
						:disabled="!selectedYear || !selectedMonth"
						:loading="isInvoiceFetching"
						@click="getInvoices"
					>
						Load more
					</v-btn>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-dialog persistent v-model="viewInvoiceModal">
			<pdf
				v-if="invoicePath"
				:src="{
					url: invoicePath
				}"
				:key="invoicePath"
				:resize="true"
			>
				<template slot="loading">
					loading content here...
				</template>
			</pdf>
			<v-layout class="white">
				<v-btn @click="downloadPdf" color="success">Download</v-btn>
				<v-btn @click="closeInvoiceModal" color="error">Close</v-btn>
			</v-layout>
		</v-dialog>
	</v-container>
</template>
<script>
import pdf from "pdfvuer";
import { mapState } from "vuex";
import {
	GET_PENDING_INVOICES,
	UPLOAD_MEDIA_TO_SERVER,
	FINANCE_BULK_APPROVAL_DSTR_INVOICE,
	SHOW_ALERT
} from "../../store/action-types";
import { __fileDownload } from "../../utils";
import { MONTHS } from "../constants";

let filePayload = null;

export default {
	props: ["appType", "themeInputColor"],
	components: {
		pdf
	},
	data() {
		return {
			isBulkApprovalInProgress: false,
			selectedMonth: "",
			selectedYear: "",
			isInvoiceFetching: false,
			approvedInvoices: [],
			headers: [
				{
					text: "Distributor Name",
					value: "retailerName",
					align: "center",
					sortable: false
				},
				{
					text: "Distributor ID",
					value: "dstrId",
					align: "center",
					sortable: false
				},
				{
					text: "City",
					value: "city",
					align: "center",
					sortable: false
				},
				{
					text: "State",
					value: "state",
					align: "center",
					sortable: false
				},
				{
					text: "View Invoice",
					value: "invoiceId",
					align: "center",
					sortable: false
				},
				{
					text: "Download Invoice",
					value: "invoiceId",
					align: "center",
					sortable: false
				}
			],
			viewInvoiceModal: false,
			invoicePath: "",
			pageLimit: 100,
			pageOffset: 0,
			showLoadMore: false,
			uploadKey: "dstrInvoiceBulkApprovalCSV"
		};
	},
	computed: {
		...mapState({
			states: state => state.common.states
		}),
		filterYears() {
			return [2021, 2022];
			// const currentYear = new Date().getFullYear();
			// return [currentYear - 1, currentYear];
		},
		filterMonths() {
			return MONTHS;
			// return MONTHS.slice(0, new Date().getMonth());
		}
	},
	methods: {
		showAlert(message) {
			this.$store.dispatch(SHOW_ALERT.dispatch, {
				text: message
			});
		},
		getInvoices() {
			if (this.isInvoiceFetching) {
				return;
			}
			this.isInvoiceFetching = true;
			this.$store
				.dispatch(GET_PENDING_INVOICES.dispatch, {
					type: "finance",
					status: "accepted",
					limit: this.pageLimit,
					offset: this.pageOffset,
					month: MONTHS.findIndex(
						month => month === this.selectedMonth
					),
					year: this.selectedYear,
					invoiceType: this.appType
				})
				.catch(() => {})
				.then(data => {
					this.showLoadMore = data.length === this.pageLimit;
					this.approvedInvoices = this.pageOffset
						? [...this.approvedInvoices, ...(data || [])]
						: [...(data || [])];
					this.pageOffset = this.approvedInvoices.length;
				})
				.finally(() => {
					this.isInvoiceFetching = false;
				});
		},
		viewInvoice(item) {
			this.viewInvoiceModal = true;
			this.invoicePath = item.url;
		},
		downloadInvoice(item) {
			__fileDownload(item.url);
		},
		downloadPdf() {
			__fileDownload(this.invoicePath);
		},
		closeInvoiceModal() {
			this.viewInvoiceModal = false;
			this.invoicePath = "";
		},
		uploadFilePath(filePath) {
			this.$store
				.dispatch(FINANCE_BULK_APPROVAL_DSTR_INVOICE.dispatch, {
					filePath: filePath,
					invoiceType: this.appType,
					month: MONTHS.findIndex(
						month => month === this.selectedMonth
					),
					year: this.selectedYear
				})
				.then(() => {
					this.showAlert("File uploaded successfully");
				})
				.catch(err => console.log(err))
				.finally(() => {
					this.isBulkApprovalInProgress = false;
				});
		},
		clearInput() {
			this.$refs.inputUpload.value = "";
			this.payload = [];
		},
		uploadBulkApprovalCsv() {
			this.clearInput();
			this.$refs.inputUpload.click();
		},
		onFileChange(e) {
			const files = e.target.files || e.dataTransfer.files;
			if (!files.length) return;
			filePayload = files[0];
			if (this.isBulkApprovalInProgress) {
				return;
			}
			this.isBulkApprovalInProgress = true;
			this.$store
				.dispatch(UPLOAD_MEDIA_TO_SERVER.dispatch, {
					key: this.uploadKey,
					file: filePayload,
					type: "csvUpload"
				})
				.then(data => {
					this.uploadFilePath(data.fileUrl);
				})
				.catch(err => console.log(err));
		}
	},
	watch: {
		selectedYear(newVal, oldVal) {
			if (oldVal !== newVal) {
				this.monthSelected = "";
			}
			this.pageOffset = 0;
		},
		selectedMonth() {
			this.pageOffset = 0;
		}
	}
};
</script>
